import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../createApiConfig';

export const PlatformApi = createApi({
  reducerPath: 'PlatformApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Platform'],
  endpoints: (builder) => ({
    listPlatforms: builder.query({
      query: (params) => ({
        url: `/platforms/?expand=user,last_updated_by`,
        params,
      }),
      providesTags: ['Platform'],
    }),

    createPlatform: builder.mutation({
      query: (data) => ({
        url: `/platforms/?expand=user,last_updated_by`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Platform'],
    }),

    updatePlatform: builder.mutation({
      query: ({ id, data }) => ({
        url: `/platforms/${id}/?expand=user,last_updated_by`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Platform'],
    }),
  }),
});

export const {
  useListPlatformsQuery,
  useCreatePlatformMutation,
  useUpdatePlatformMutation,
} = PlatformApi;
